import { TDate } from '@/components/i18n/date.i18n.component';
import { TTime } from '@/components/i18n/time.i18n.component';
import { useTailoringStore } from '@/store/pre-tailoring.store';
import { useIntl } from 'react-intl';
import { pretailoringPageMessages } from '../../../pages/pre-tailoring/pre-tailoring.messages';

const getUpdatedAt = (productId: string, products: { productId?: string; lastUpdate: Date; lastUsed: Date }[]) => {
  const product = products.find((p) => p.productId === productId);
  if (!product) return null;
  return product.lastUpdate;
};

type Props = {
  productId: string;
};

export const SavedAt = ({ productId, ...props }: Props) => {
  const t = useIntl();

  const { products: storedProducts } = useTailoringStore((state) => state);

  return (
    productId && (
      <p data-testid="saved-at" className="typo-secondary text-secondary-text" {...props}>
        {t.formatMessage(pretailoringPageMessages.updatedAt, {
          date: <TDate value={new Date(getUpdatedAt(productId, storedProducts) || new Date())} />,
          time: (
            <TTime
              value={new Date(getUpdatedAt(productId, storedProducts) || new Date())}
              hour="numeric"
              minute="numeric"
              second="numeric"
            />
          ),
        })}
      </p>
    )
  );
};
